const w = window.innerWidth / 160;
const h = window.innerHeight / 160;

export const quantize = (x, y) =>{
    return {
        x: w * Math.round(x / w), 
        y: h * Math.round(y / h)
    }
} 
